import styled, { css } from 'styled-components';
import { deviceWidths } from '../../variables/widths.js';

var FilterBarWrapper = styled.div.withConfig({
  displayName: "style__FilterBarWrapper",
  componentId: "sc-2ejpxe-0"
})([".sg-filter-bar__overlay{@media (min-width:", "){overflow-y:visible;position:static;z-index:1;}", "}.sg-filter-bar__popup{min-height:100%;padding-bottom:100px;position:relative;@media (max-width:", "){margin:0;max-height:100%;max-width:", ";}@media (min-width:", "){display:block;z-index:1;max-width:none;max-height:none;}}"], deviceWidths.desktop, function (props) {
  return props.closed && css(["@media (max-width:", "){display:none;}"], deviceWidths.desktopMax);
}, deviceWidths.desktopMax, deviceWidths.largeMobile, deviceWidths.desktop);

export { FilterBarWrapper };
//# sourceMappingURL=style.js.map
